import React from 'react';
import { useTeamsContext } from './hooks/useTeamsContext';
import { PrimaryRecruiterForm, HiringManagersForm } from './components';
import './App.css';
import './styles/TeamsTheme.css';

function App() {
  const { userInfo } = useTeamsContext();

  return (
    <div className="teams-container">
      <div className="teams-card">
        <div className="teams-section-header centered">
          <h1 className="teams-section-title main-title">Recruiter Setup</h1>
        </div>
  
        {/* Recruiter Setup Form */}
        <div className="recruiter-form">
          {/* Primary Recruiter Section */}
          <PrimaryRecruiterForm userInfo={userInfo} />

          {/* Hiring Manager Section */}
          <HiringManagersForm userInfo={userInfo} />
        </div>
      </div>
    </div>
  );
}

export default App;
